import React, { useState, useContext, useRef } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import ForwardMessageModal from "../ForwardMessageModal";
import EditMessageModal from "../EditMessageModal";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl, groq }) => {
	const { setReplyingMessage } = useContext(ReplyMessageContext);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [forwardMessageModalOpen, setForwardMessageModalOpen] = useState(false);
	const [confirmationEditOpen, setEditMessageOpenModal] = useState(false);
	const [messageEdit, setMessageEdit] = useState(false);
	const isMounted = useRef(true);

	const handleForwardMessage = () => {
		setForwardMessageModalOpen(true)
		handleClose();
	};

	const handleCloseForwardMessageModal = () => {
		if (isMounted.current) {
			setForwardMessageModalOpen(false);
		}
	};

	const handleDeleteMessage = async () => {
		try {
			await api.delete(`/messages/${message.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleEditMessage = async () => {
		try {
			await api.put(`/messages/${message.id}`);
		} catch (err) {
			toastError(err);
		}
	}

	const hanldeReplyMessage = () => {
		setReplyingMessage(message);
		handleClose();
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenEditMessageModal = e => {
		setEditMessageOpenModal(true);
		setMessageEdit(message);
		handleClose();
	};

	const hanldeTranscriptionMessage = async () => {
		try {
			await api.post(`/messages/transcription/${message.id}`);
			handleClose();
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<>
			<ConfirmationModal
				title="Eliminar Mensaje"
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteMessage}
			>
				¿Estás seguro? ¡Esta acción no se puede deshacer!
			</ConfirmationModal>
			<EditMessageModal
				title="Editar Mensaje"
				open={confirmationEditOpen}
				onClose={setEditMessageOpenModal}
				onSave={handleEditMessage}
				message={message}
			>
				Edita el contenido del mensaje
			</EditMessageModal>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				{message.fromMe && (
					<MenuItem onClick={handleOpenEditMessageModal}>
						Editar
					</MenuItem>
				)}
				{message.fromMe && (
					<MenuItem onClick={handleOpenConfirmationModal}>
						Eliminar
					</MenuItem>
				)}
				<MenuItem onClick={hanldeReplyMessage}>
					Responder
				</MenuItem>
				<MenuItem onClick={() => handleForwardMessage()}>
					Reenviar
				</MenuItem>
				{message.mediaType === "audio" && groq !== "" && (
					<MenuItem onClick={hanldeTranscriptionMessage}>
						Transcripción
					</MenuItem>
				)}
			</Menu>
			<ForwardMessageModal
				modalOpen={forwardMessageModalOpen}
				onClose={handleCloseForwardMessageModal}
				message={message}
			/>
		</>
	);
};

export default MessageOptionsMenu;
